import Image from "../gui/Image";
import AbstractProvidedClass from "./AbstractProvidedClass";
import { migrate } from "./DataMigrator";

export default class AbstractDataHandler extends AbstractProvidedClass {
    get csrfToken() {
        return this.p.select('meta[name="csrf-token"]')?.elt?.content || '';
    }

    executeGetRequest(uri, func) {
        this.p.httpDo(
            uri,
            {
                method: 'GET',
                headers: {
                    'X-CSRF-Token': this.csrfToken,
                    'Accept': 'application/json',
                }
            },
            (data) => {
                data = JSON.parse(data);
                func(data);
                this.spinner.reset();
            },
            (data) => {
                console.log(JSON.parse(data));
            }
        )
    }

    executeSaveRequest(uri, method, body, func) {
        window['saveButton'].html('...');
        this.p.httpDo(
            uri,
            {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': this.csrfToken,
                    'Accept': 'application/json',
                },
                body: JSON.stringify(body)
            },
            (data) => {
                data = JSON.parse(data);
                this.storage.empty();
                this.changesSaved();
                func(data);
            },
            (data) => {
                console.log(JSON.parse(data));
            }
        );
    }

    loadData(data, storageData = null) {
        if (storageData && storageData.timestamp >= data.timestamp) {
            this.changesMade(true);
        }
        let newData = migrate(data, storageData);
        this.speciesCollection.init(newData.species);
        this.view.init(newData.view);
        this.settings.init(newData.settings);
        this.elements.init(newData.elements);
        if (newData.image) {
            this.imageMenu?.loading();
            this.image = new Image(this.provider, newData.image);
        }
        this.planName = newData.name;
        this.grid.recalculate();
        this.loaded = true;
        return newData;
    }
}
